import { render } from "./TermsAndConditionsModal.vue?vue&type=template&id=a4a33f92&scoped=true&ts=true"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=a4a33f92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a33f92"]])

export default __exports__